<!--
 * @Author: zyy
 * @Date: 2023-09-06 14:46:33
 * @LastEditTime: 2023-09-06 15:19:35
 * @FilePath: /tjzhsq-admin/src/views/platform/vip/experience/index.vue
 * @Description: yahu~
 * 
-->
<template>
    <div class="member-manage app-region blank-t-v blank-l-h blank-r-h">
        <a-table class="mg-normal" :loading="table.loading" :columns="columns" :data-source="table.data" rowKey="id"
            :pagination="ipagination" @change="handlePageChange">
            <template slot="status" slot-scope="text, data">
                <a-switch :checked="data.status === 1" @click="stateChange(data)"></a-switch>
            </template>
            <template slot="action" slot-scope="text, data">
                <a-space>
                    <a-button type="link" @click="handleOpen(data)">编辑</a-button>
                </a-space>
            </template>
        </a-table>
        <Edit @submit="getList" ref="editRef" v-if="showEdit" @close="showEdit = false"></Edit>
    </div>
</template>
  
<script>
import { TJListMixin } from '@/mixins/list.js'
import ExpService from '@/io/vip/exp.js'
import Edit from './edit.vue'

export default {
    name: 'ExplList',
    mixins: [TJListMixin],
    components: { Edit },
    data() {
        return {
            service: ExpService,
            columns: [
                {
                    title: '操作事件',
                    dataIndex: 'name'
                },
                {
                    title: '类型',
                    dataIndex: 'type',
                    customRender: text => text === 1 ? '消费金额' : '每次'
                },

                {
                    title: '事件',
                    dataIndex: 'points',
                    customRender: (text, row) => {
                        return `${row.type === 1 ? `每消费${row.amount}角` : ''}获得${text}成长值`
                    }
                },
                {
                    title: '状态',
                    scopedSlots: { customRender: 'status' },
                },
                {
                    title: '操作',
                    with: 200,
                    scopedSlots: { customRender: 'action' },
                }
            ]
        }
    },
    methods: {
        async stateChange(row) {
            await this.service.setStatus({ id: row.id, status: row.status === 1 ? 0 : 1 })
            this.$message.success('修改成功')
            this.getList()
        }
    }
}


</script>
  
<style lang="less" scoped></style>